import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ANALYTICS_ERROR_TYPE } from '@/shared/services/analytics.enum';
import { AnalyticsService } from '@/shared/services/analytics.service';
import { NavigationService } from '@/shared/services/navigation.service';

export const APIErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const analyticsService = inject(AnalyticsService);
  const navigationService = inject(NavigationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMsg = '';
      if (error.error instanceof ErrorEvent) {
        errorMsg = error?.error?.message;
      } else {
        errorMsg = error?.message;
      }

      if (error.status === 401 || error.status === 403) {
        navigationService.toAppStart();
        return EMPTY;
      } else if (error.status >= 500) {
        analyticsService.trackSiteErrorEvent(ANALYTICS_ERROR_TYPE.API, error?.status, errorMsg);
        if (!window.location.pathname.includes('api-error')) {
          if (req.url.includes(environment.gcp.identificationUrl)) {
            const redirectTo = window?.location?.href.includes('?embeddedWebApp=true')
              ? '/status/identification/identification-failed?embeddedWebApp=true'
              : '/status/identification/identification-failed';
            navigationService.toUrl(redirectTo);
            return EMPTY;
          } else {
            if (
              req.url.includes(environment.gcp.outagesUrl) ||
              req.url.includes(environment.gcp.diagnostics.accountCheck)
            ) {
              navigationService.toUrl('status/error');
              return EMPTY;
            } else {
              if (!req.url.endsWith(environment.gcp.diagnostics.diagnosticCheck) && 
                  !req.url.includes(environment.gcp.pinHoleReset?.retrieve)) {
                navigationService.toApiError(error?.status, error?.url);
                return EMPTY;
              }
            }
          }
        }
      }

      return throwError(() => error);
    })
  );
};
